import { loadSwiper } from './swiper-loader.js';

if (!customElements.get('split-media-text')) {
    class SplitMediaText extends HTMLElement {
        constructor() {
            super();

            this.swiper = null;
        }

        #onToggleClick = (event) => {
            const elToggle = event.target.closest('[data-toggle]');
            if (!elToggle || !this.contains(elToggle)) return;

            const elBlock = elToggle.closest('[data-block]');
            if (!elBlock) return;

            this.#setBlockMedia(elBlock);
        };

        connectedCallback() {
            this.elMedia = this.querySelector('[data-media]');
            this.elBlocksCarousel = this.querySelector('.split-media-text--blocks');
            this.elNext = this.querySelector('[data-navigation="next"]');
            this.elPrev = this.querySelector('[data-navigation="prev"]');

            this.addEventListener('click', this.#onToggleClick);
            this.initCarousel();
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.#onToggleClick);
            this.swiper?.destroy(true, true);
            this.swiper = null;
        }

        async initCarousel() {
            const elSlides = this.querySelectorAll('.swiper-slide');
            const enabled = elSlides.length > 1;

            this.swiper?.destroy(true, true);

            if (!enabled) {
                this.elNext?.closest('.split-media-text--nav')?.style.setProperty('display', 'none');
                this.elBlocksCarousel?.setAttribute('data-swiper-ready', '');
                return;
            }

            const Swiper = await loadSwiper();
            this.swiper = new Swiper(this.elBlocksCarousel, {
                enabled: true,
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 12,
                slidesOffsetAfter: 12,
                speed: 500,
                navigation: {
                    nextEl: this.elNext,
                    prevEl: this.elPrev,
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                },
                breakpoints: {
                    1024: {
                        enabled: false,
                        spaceBetween: 0,
                    },
                },
                on: {
                    slideChange: (s) => {
                        const elBlock = s.slides[s.activeIndex];
                        if (elBlock) this.#setBlockMedia(elBlock);
                    },
                },
            });

            this.elBlocksCarousel.setAttribute('data-swiper-ready', '');
        }

        #setBlockMedia(elBlock) {
            const elTemplate = elBlock.querySelector('[data-block-media]');
            if (!elTemplate?.content || !this.elMedia) return;

            for (const elVideo of this.elMedia.querySelectorAll('video')) {
                elVideo.pause();
            }

            const fragment = elTemplate.content.cloneNode(true);

            for (const elImage of fragment.querySelectorAll('img')) {
                elImage.setAttribute('loading', 'eager');
                elImage.setAttribute('fetchpriority', 'high');
            }

            this.elMedia.replaceChildren(fragment);
            this.#setActiveBlock(elBlock);
        }

        #setActiveBlock(elBlock) {
            for (const block of this.querySelectorAll('[data-block]')) {
                const isActive = block === elBlock;
                block.classList.toggle('active', isActive);
                block.querySelector('[data-toggle]')?.setAttribute('aria-pressed', String(isActive));
                block.querySelector('.split-media-text--block-heading')?.classList.toggle('active', isActive);
            }
        }
    }

    customElements.define('split-media-text', SplitMediaText);
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (ev) => {
        const elSplitMediaText = ev.target.querySelector('split-media-text');
        if (elSplitMediaText) elSplitMediaText.initCarousel();
    });
}
